// import React, { useState, useEffect } from "react";
// // import { Link } from "feather-icons-react/build/IconComponents";
// import { AgGridReact } from "ag-grid-react";
// import "@ag-grid-community/styles/ag-grid.css";
// import "@ag-grid-community/styles/ag-theme-alpine.css";
// import "@ag-grid-enterprise/excel-export";
// // import { ChevronUp, RotateCcw } from "feather-icons-react/build/IconComponents";
// // import { Tooltip } from "react-bootstrap";
// import Select from "react-select";
// import * as XLSX from "xlsx";
// import jsPDF from "jspdf";
// import "jspdf-autotable";
// import EXCELIMG from "./excel.svg";
// import PDFIMG from "./pdf.svg";
// import PDFLOGO from "./ibizlogo.jpg";
// import Axios from "axios";
// import { useParams } from "react-router-dom";
// import {
//   API_BASE_URL,
//   GET_REPORT_FILTERS,
//   GET_REPORT_DATA,
//   GET_VSTORE_PROD,
//   GET_USER_STORES,
// } from "../../Config";
// // import DateRangePicker from "react-bootstrap-daterangepicker";
// // import { Calendar } from "feather-icons-react/build/IconComponents";

// export default function SalesReport() {
//   const { reportid } = useParams();
//   const [userDataSession, setUserDataSession] = useState([]);
//   const [rowData, setRowData] = useState([]);
//   const [colDefs, setColDefs] = useState([]);
//   const [reportInfo, setReportInfo] = useState([]);
//   const [reportInfoSub, setReportInfoSub] = useState([]);
//   const [reportFilters, setReportFilters] = useState([]);
//   const [staffDDL, setStaffDDL] = useState([]);
//   const [storeDDL, setStoreDDL] = useState([]);
//   const [productDDL, setProductDDL] = useState([]);
//   const [supplierDDL, setSupplierDDL] = useState([]);
//   const [customerDDL, setCustomerDDL] = useState([]);
//   const [categoryDDL, setCategoryDDL] = useState([]);
//   const [citiesDDL, setCitiesDDL] = useState([]);
//   const [loading, setLoading] = useState(false);

//   const getFormattedDate = (date) => {
//     const year = date.getFullYear();
//     const month = String(date.getMonth() + 1).padStart(2, "0"); // Add 1 to month since it's zero-based
//     const day = String(date.getDate()).padStart(2, "0");
//     return `${year}-${month}-${day}`;
//   };

//   // Selected
//   const [selectedFromDate, setSelectedFromDate] = useState("");
//   const [selectedToDate, setSelectedToDate] = useState(getFormattedDate(new Date()));
//   const [selectedStaff, setSelectedStaff] = useState(null);
//   const [selectedStore, setSelectedStore] = useState(null);
//   const [selectedProduct, setSelectedProduct] = useState(null);
//   const [selectedSupplier, setSelectedSupplier] = useState(null);
//   const [selectedCustomer, setSelectedCustomer] = useState(null);
//   const [selectedCategory, setSelectedCategory] = useState(null);
//   const [selectedCity, setSelectedCity] = useState(null);
//   const [selectedIndStatus, setSelectedIndStatus] = useState(null);
//   // const [selectedLocalIndStatus, setSelectedLocalIndStatus] = useState(null);

//   useEffect(() => {
//     const userDataString = sessionStorage.getItem("userData");
//     const supplierData = JSON.parse(sessionStorage.getItem("filteredDDLData_Supplier"));
//     const customerData = JSON.parse(sessionStorage.getItem("filteredDDLData_Customers"));
//     const categoryData = JSON.parse(sessionStorage.getItem("filteredDDLData_CATEGORY"));
//     const citiesData = JSON.parse(sessionStorage.getItem("filteredDDLData_Cities"));
//     // const subcategoryData = JSON.parse(sessionStorage.getItem('filteredDDLData_Subcategories'));
//     // const productData = JSON.parse(sessionStorage.getItem("filteredDDLData_Products"));
//     // const variantypesData = JSON.parse(sessionStorage.getItem('filteredDDLData_variantypes'));
//     // const taxData = JSON.parse(sessionStorage.getItem('filteredDDLData_TAX'));
//     // const storesData = JSON.parse(sessionStorage.getItem("filteredDDLData_Stores"));
//     // const brandsData = JSON.parse(sessionStorage.getItem('filteredDDLData_BRAND'));
//     // const rolesData = JSON.parse(sessionStorage.getItem('filteredDDLData_Role));
//     const staffData = JSON.parse(
//       sessionStorage.getItem("filteredDDLData_Staff")
//     );

//     if (userDataString) {
//       const userData = JSON.parse(userDataString);
//       setUserDataSession(userData);
//       setStaffDDL(staffData);
//       setSupplierDDL(supplierData);
//       setCustomerDDL(customerData);
//       setCategoryDDL(categoryData);
//       setCitiesDDL(citiesData);
//     } else {
//       console.log("User data not found in sessionStorage");
//     }
//   }, []);

//   const indStatusOptions = [
//     { value: "0", label: "All" },
//     { value: "2", label: "Submitted" },
//     { value: "3", label: "Approved" },
//     { value: "4", label: "Reject" },
//     { value: "5", label: "Completed" }
//   ];

//   const localIndStatusOptions = [
//     { value: "12", label: "Local Purchase Submitted" },
//     { value: "13", label: "Local Purchase Approved" },
//     { value: "14", label: "Local Purchase Reject" },
//     { value: "15", label: "Local Purchase Completed" },
//   ];

//   useEffect(() => {
//     if (userDataSession && userDataSession.OrgId) {
//       const requestData = {
//         OrgId: userDataSession.OrgId,
//         CategoryId: 0,
//         BarCode: "0",
//         IsActive: 1,
//         ProductId: 0,
//         StoreId: 0,
//         IsForSale: 1,
//         UserId: userDataSession.UserId,
//         Type: 0,
//       };

//       Axios.post(`${API_BASE_URL}${GET_VSTORE_PROD}`, requestData)
//         .then((response) => {
//           if (response.data.Status) {
//             setProductDDL(response.data.ResultData);
//           } else {
//             console.error("Error fetching data:", response.data.Message);
//           }
//         })
//         .catch((error) => {
//           console.error("Error fetching data:", error);
//         });
//     }
//   }, [userDataSession]);

//   useEffect(() => {
//     if (userDataSession && userDataSession.OrgId) {
//       Axios.get(
//         `${API_BASE_URL}${GET_USER_STORES}?OrgId=${userDataSession.OrgId}&UserId=${userDataSession.UserId}`
//       )
//         .then((response) => {
//           if (response.data) {
//             setStoreDDL(response.data.ResultData);
//           } else {
//             console.error("Error fetching data:", response.data);
//           }
//         })
//         .catch((error) => {
//           console.error("Error fetching data:", error);
//         });
//     }
//   }, [userDataSession]);

//   useEffect(() => {
//     // Set the initial value for From Date to the first of the current month
//     const firstDateOfMonth = new Date();
//     firstDateOfMonth.setDate(1); // Set date to 1
//     setSelectedFromDate(getFormattedDate(firstDateOfMonth)); // Format it

//     // Optionally, set To Date to today or another default
//     setSelectedToDate(getFormattedDate(new Date()));
//   }, []);

//   useEffect(() => {
//     console.log("report id chanegd", reportid);
//     if (reportid) {
//       const firstDateOfMonth = new Date();
//       firstDateOfMonth.setDate(1); // Set date to the 1st
//       setSelectedFromDate(getFormattedDate(firstDateOfMonth));
//       setSelectedToDate(getFormattedDate(new Date()));
//       setSelectedCategory(null);
//       setSelectedCustomer(null);
//       setSelectedProduct(null);
//       setSelectedStaff(null);
//       setSelectedStore(null);
//       setSelectedCity(null);
//       setSelectedSupplier(null);
//       setSelectedIndStatus(null);
//       setReportInfoSub([]);
//       setColDefs([]);
//       setRowData([]);
//     }
//   }, [reportid]);

//   useEffect(() => {
//     if (userDataSession && userDataSession.OrgId && reportid) {
//       Axios.get(
//         `${API_BASE_URL}${GET_REPORT_FILTERS}?OrgId=${userDataSession.OrgId}UserId=${userDataSession.UserId}&ReportId=${reportid}`
//       )
//         .then((response) => {
//           if (response.data.Status) {
//             setReportFilters(response.data.ResultData[0]);
//             setReportInfo(response.data.ResultData);
//             console.log(response.data.ResultData[0], "filters data");
//           } else {
//             console.error("Error fetching data:", response.data.Message);
//           }
//         })
//         .catch((error) => {
//           console.error("Error fetching data:", error);
//         });
//     }
//   }, [userDataSession, reportid]);

//   const filtersArray = reportFilters.ReportFilter
//     ? reportFilters.ReportFilter.split(",")
//     : [];

//   const handleFromDateChange = (event) => {
//     setSelectedFromDate(event.target.value);
//   };

//   const handleToDateChange = (event) => {
//     setSelectedToDate(event.target.value);
//   };

//   const handleStaffChange = (selectedOption) => {
//     setSelectedStaff(selectedOption);
//   };

//   const handleStoreChange = (selectedOption) => {
//     setSelectedStore(selectedOption);
//   };

//   const handleSupplierChange = (selectedOption) => {
//     setSelectedSupplier(selectedOption);
//   };

//   const handleCustomerChange = (selectedOption) => {
//     setSelectedCustomer(selectedOption);
//   };

//   const handleProductChange = (selectedOption) => {
//     setSelectedProduct(selectedOption);
//   };

//   const handleCategoryChange = (selectedOption) => {
//     setSelectedCategory(selectedOption);
//   };

//   const handleCityChange = (selectedOption) => {
//     setSelectedCity(selectedOption);
//   };

//   const handleIndStatusChange = (selectedOption) => {
//     setSelectedIndStatus(selectedOption);
//   };

//   // const handleLocalIndStatusChange = (selectedOption) => {
//   //   setSelectedLocalIndStatus(selectedOption);
//   // };

//   const handleSearch = () => {
//     if (userDataSession && userDataSession.OrgId) {
//       setLoading(true);

//       const requestData = {
//         OrgId: userDataSession.OrgId,
//         UserId: userDataSession.UserId,
//         ReportId: reportid,
//         ReportCriteria: {
//           FromDate: selectedFromDate,
//           ToDate: selectedToDate,
//           ProductId: selectedProduct ? selectedProduct.value : "0",
//           SupplierId: selectedSupplier ? selectedSupplier.value : "0",
//           UserId: selectedStaff ? selectedStaff.value : "0",
//           LoginUserId: userDataSession ? userDataSession.UserId : "0",
//           StoreId: selectedStore ? selectedStore.value : "0",
//           CustomerId: selectedCustomer ? selectedCustomer.value : "0",
//           CategoryId: selectedCategory ? selectedCategory.value : "0",
//           City: selectedCity ? selectedCity.value : "0",
//           Status: selectedIndStatus ? selectedIndStatus.value : "0",
//           // Status: selectedLocalIndStatus ? selectedLocalIndStatus.value : "0",
//         },
//       };
//       console.log(requestData, "data sending to api");

//       Axios.post(`${API_BASE_URL}${GET_REPORT_DATA}`, requestData)
//         .then((response) => {
//           console.log(response.data, "response from service");
//           if (response.data) {
//             const { data, headers, reportinfo } = response.data;
//             console.log(response.data, "data egtting from api");
//             // Generate column definitions based on headers
//             const colDefs = headers.map((header, index) => ({
//               headerName: header,
//               field: `col${index}`,
//               sortable: true,
//               filter: true,
//             }));

//             // Map data to match column definitions
//             const rowData = data.map((row) => {
//               const rowDataObj = {};
//               headers.forEach((header, index) => {
//                 rowDataObj[`col${index}`] = row[Object.keys(row)[index]];
//               });
//               return rowDataObj;
//             });

//             setRowData(rowData);
//             setColDefs(colDefs);
//             setReportInfoSub(reportinfo);
//             setLoading(false);
//           } else {
//             console.error("Error fetching data:", response.data);
//             setLoading(false);
//           }
//         })
//         .catch((error) => {
//           console.error("Error fetching data:", error);
//           setLoading(false);
//         });
//     }
//   };

//   const handleDownloadExcel = () => {
//     if (rowData.length === 0) {
//       return;
//     }

//     const headers = colDefs.map(col => col.headerName);
//     const wsData = rowData.map((item) => {
//       const row = {};
//       colDefs.forEach((col) => {
//         row[col.headerName] = item[col.field];
//       });
//       return row;
//     });
//       const wb = XLSX.utils.book_new();
//       const ws = XLSX.utils.json_to_sheet(wsData, { header: headers });
//       XLSX.utils.book_append_sheet(wb, ws, "ReportsData");
//       XLSX.writeFile(wb, "ReportsData.xlsx");
//   };

//   const generatePDF = () => {
//     if (rowData.length === 0) {
//       return;
//     }

//     const doc = new jsPDF({
//       orientation: "landscape",
//     });

//     doc.setProperties({
//       title: "Reports Data",
//       author: "Meghawi",
//       creator: "Ibiz Application",
//     });

//     const logoUrl = PDFLOGO;
//     const logoX = 10;
//     const logoY = 10;
//     const logoWidth = 65;
//     const logoHeight = 20;

//     doc.addImage(logoUrl, "PNG", logoX, logoY, logoWidth, logoHeight);

//     const headers = colDefs.map(col => col.headerName);
//     const tableData = rowData.map((item) =>
//       headers.map((header) => {
//         const field = colDefs.find(col => col.headerName === header).field;
//         return item[field] || "";
//       })
//     );

//     doc.autoTable({
//       head: [headers],
//       body: tableData,
//       startY: logoY + logoHeight + 10,
//       margin: { horizontal: 10 },
//       styles: {
//         overflow: "linebreak",
//         cellPadding: 3,
//         fontSize: 10,
//         valign: "middle",
//         cellWidth: "wrap",
//       },
//       headStyles: {
//         fillColor: [22, 160, 133],
//         textColor: [255, 255, 255],
//         fontStyle: 'bold',
//       },
//       bodyStyles: {
//         fillColor: [255, 255, 255],
//         textColor: [0, 0, 0],
//       },
//       columnStyles: {
//         0: { cellWidth: 30 },
//         1: { cellWidth: 30 },
//         2: { cellWidth: 40 },
//       },
//       didDrawPage: function (data) {
//         doc.setFontSize(12);
//         doc.text("Wastage Report", 10, 10);
//         doc.text(`Page ${data.pageCount}`, doc.internal.pageSize.width - 20, 10);
//       },
//       pageBreak: "auto",
//     });

//     doc.save("ReportsData.pdf");
//   };

//   const handleReload = () => {
//     window.location.reload();
//   };

//   return (
//     <div className="page-wrapper">
//       <div className="content">
//         <div className="page-header transfer">
//           <div className="add-item d-flex">
//             <div className="page-title">
//               <h4>{reportInfo[0] && reportInfo[0].ReportTitle}</h4>
//               <h6>{reportInfoSub[0] && reportInfoSub[0]["Report Tit"]}</h6>
//             </div>
//           </div>
//           <ul className="table-top-head">
//             <li>
//               <button className="btn border">
//                 <img
//                   src={EXCELIMG}
//                   alt="ExcelImg"
//                   onClick={handleDownloadExcel}
//                 />
//               </button>
//             </li>
//             <li>
//               <button className="btn border">
//                 <img src={PDFIMG} alt="PDFIMG" onClick={generatePDF} />
//               </button>
//             </li>

//             <li onClick={handleReload}>
//               <button className="btn border ">
//                 <i className="fa-solid fa-rotate-right fs-5"></i>
//               </button>
//             </li>
//           </ul>
//         </div>
//         <div className="card table-list-card">
//           {/* Filter Options */}
//           <div className="row my-2 ms-2">

//             {/* From Date */}
//             {filtersArray.includes("FromDate") && (
//               <div className="col-lg-2 col-sm-6 col-12">
//                 <label className="form-label">From Date</label>
//                 <div className="input-bloks">
//                   <input
//                     className="form-control"
//                     type="date"
//                     value={selectedFromDate}
//                     onChange={handleFromDateChange}
//                   />
//                 </div>
//               </div>
//             )}

//             {/* To Date */}
//             {filtersArray.includes("ToDate") && (
//               <div className="col-lg-2 col-sm-6 col-12">
//                 <label className="form-label">To Date</label>
//                 <div className="input-bloks">
//                   <input
//                     className="form-control"
//                     type="date"
//                     value={selectedToDate}
//                     onChange={handleToDateChange}
//                   />
//                 </div>
//               </div>
//             )}

//             {/* Store */}
//             {filtersArray.includes("StoreId") && (
//               <div className="col-lg-2 col-sm-6 col-12">
//                 <label className="form-label">Store</label>
//                 <div className="input-bloks">
//                   <Select
//                     className="select"
//                     id="storeSelect"
//                     value={selectedStore || null}
//                     onChange={handleStoreChange}
//                     options={
//                       storeDDL
//                         ? storeDDL.map((store) => ({
//                             value: store.StoreId,
//                             label: store.Name,
//                           }))
//                         : []
//                     }
//                     placeholder="Choose store"
//                   />
//                 </div>
//               </div>
//             )}

//             {/* Category */}
//             {filtersArray.includes("CategoryId") && (
//               <div className="col-lg-2 col-sm-6 col-12">
//                 <label className="form-label">Category</label>
//                 <div className="input-bloks">
//                   <Select
//                     className="select"
//                     id="productSelect"
//                     value={selectedCategory || null}
//                     onChange={handleCategoryChange}
//                     options={
//                       categoryDDL
//                           ? [{ value: 0, label: "All" }, ...categoryDDL.map((prod) => ({
//                               value: prod.ItemId,
//                               label: prod.ItemValue,
//                             }))]
//                           : [{ value: 0, label: "All" }]
//                       }
//                     placeholder="Choose category"
//                   />
//                 </div>
//               </div>
//             )}

//             {/* Cities */}
//             {filtersArray.includes("City") && (
//               <div className="col-lg-2 col-sm-6 col-12">
//                 <label className="form-label">City</label>
//                 <div className="input-bloks">
//                   <Select
//                     className="select"
//                     id="citySelect"
//                     value={selectedCity || null}
//                     onChange={handleCityChange}
//                     options={
//                       citiesDDL
//                         ? [{ value: 0, label: "All" }, ...citiesDDL.map((prod) => ({
//                             value: prod.ItemValue,
//                             label: prod.ItemValue,
//                           }))]
//                         : [{ value: 0, label: "All" }]
//                       }
//                     placeholder="Choose city"
//                   />
//                 </div>
//               </div>
//             )}

//             {/* Status */}
//             {filtersArray.includes("Status") && (
//               <div className="col-lg-2 col-sm-6 col-12">
//                 <label className="form-label">Status</label>
//                 <div className="input-bloks">
//                   <Select
//                     className="select"
//                     id="statusSelect"
//                     value={selectedIndStatus || null}
//                     onChange={handleIndStatusChange}
//                     options={indStatusOptions}
//                     placeholder="Choose status"
//                   />
//                 </div>
//               </div>
//             )}

//             {filtersArray.includes("LocalStatus") && (
//               <div className="col-lg-2 col-sm-6 col-12">
//                 <label className="form-label">Status</label>
//                 <div className="input-bloks">
//                   <Select
//                     className="select"
//                     id="statusSelect"
//                     value={selectedIndStatus || null}
//                     onChange={handleIndStatusChange}
//                     options={localIndStatusOptions}
//                     placeholder="Choose status"
//                   />
//                 </div>
//               </div>
//             )}

//             {/* Supplier */}
//             {filtersArray.includes("SupplierId") && (
//               <div className="col-lg-2 col-sm-6 col-12">
//                 <label className="form-label">Supplier</label>
//                 <div className="input-bloks">
//                   <Select
//                     className="select"
//                     id="productSelect"
//                     value={selectedSupplier || null}
//                     onChange={handleSupplierChange}
//                     options={
//                       supplierDDL
//                         ? [{ value: 0, label: "All" }, ...supplierDDL.map((prod) => ({
//                             value: prod.ItemId,
//                             label: prod.ItemValue,
//                           }))]
//                         : [{ value: 0, label: "All" }]
//                       }
//                     placeholder="Choose supplier"
//                   />
//                 </div>
//               </div>
//             )}

//             {/* Customer */}
//             {filtersArray.includes("CustomerId") && (
//               <div className="col-lg-2 col-sm-6 col-12">
//                 <label className="form-label">Customer</label>
//                 <div className="input-bloks">
//                   <Select
//                     className="select"
//                     value={selectedCustomer || null}
//                     onChange={handleCustomerChange}
//                     options={
//                       customerDDL
//                         ? [{ value: 0, label: "All" }, ...customerDDL.map((prod) => ({
//                             value: prod.ItemId,
//                             label: prod.ItemValue,
//                           }))]
//                         : [{ value: 0, label: "All" }]
//                       }
//                     placeholder="Choose customer"
//                   />
//                 </div>
//               </div>
//             )}

//             {/* Product */}
//             {filtersArray.includes("ProductId") && (
//               <div className="col-lg-2 col-sm-6 col-12">
//                 <label className="form-label">Product</label>
//                 <div className="input-bloks">
//                   <Select
//                     className="select"
//                     value={selectedProduct || null}
//                     onChange={handleProductChange}
//                     options={productDDL.map((prod) => ({
//                       value: prod.Id,
//                       label: prod.ProductName,
//                     }))}
//                     placeholder="Choose product"
//                   />
//                 </div>
//               </div>
//             )}

//             {/* Staff */}
//             {filtersArray.includes("UserId") && (
//               <div className="col-lg-2 col-sm-6 col-12">
//                 <label className="form-label">Employee</label>
//                 <div className="input-bloks">
//                   <Select
//                     className="select"
//                     id="employeeSelect"
//                     value={selectedStaff || null}
//                     onChange={handleStaffChange}
//                     options={
//                       staffDDL
//                         ? [{ value: 0, label: "All" }, ...staffDDL.map((prod) => ({
//                             value: prod.ItemId,
//                             label: prod.ItemValue,
//                           }))]
//                         : [{ value: 0, label: "All" }]
//                       }
//                     placeholder="Choose employee"
//                   />
//                 </div>
//               </div>
//             )}

//             <div className="col-md-1 col-sm-1 col-lg-1 mt-4">
//               <button className="btn btn-primary" onClick={handleSearch}>
//                 <i className="fa-solid fa-magnifying-glass"></i>
//               </button>
//             </div>
//           </div>
//           {/* Filter Options */}

//           <div
//             className="ag-theme-alpine"
//             style={{ height: 380, width: "100%" }}
//           >
//             {loading ? (
//               <div className="loader m-auto mt-5"></div>
//             ) : (
//               // <AgGridReact
//               //   defaultColDef={{ sortable: true, filter: true, flex: 1 }}
//               //   pagination={true}
//               //   rowData={rowData}
//               //   columnDefs={colDefs}
//               //   onGridReady={(params) => params.api.sizeColumnsToFit()}
//               // />
//               <AgGridReact
//                 defaultColDef={{ sortable: true, filter: true, flex: 1 }}
//                 pagination={true}
//                 paginationPageSize={10}
//                 rowData={rowData}
//                 columnDefs={colDefs}
//                 onGridReady={(params) => params.api.sizeColumnsToFit()}
//                 domLayout="autoHeight"
//               />
//             )}
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// }

import React, { useState, useEffect, useCallback } from "react";
import { AgGridReact } from "ag-grid-react";
import "@ag-grid-community/styles/ag-grid.css";
import "@ag-grid-community/styles/ag-theme-alpine.css";
import "@ag-grid-enterprise/excel-export";
import Select from "react-select";
import * as XLSX from "xlsx";
import jsPDF from "jspdf";
import "jspdf-autotable";
import EXCELIMG from "./excel.svg";
import PDFIMG from "./pdf.svg";
import PDFLOGO from "./ibizlogo.jpg";
import Axios from "axios";
import { useParams } from "react-router-dom";
import {
  API_BASE_URL,
  GET_REPORT_FILTERS,
  GET_REPORT_DATA,
  GET_VSTORE_PROD,
  GET_USER_STORES,
} from "../../Config";
import SpinLoader from "../loader/SpinLoader";

export default function SalesReport() {
  const { reportid } = useParams();
  const [userDataSession, setUserDataSession] = useState([]);
  const [rowData, setRowData] = useState([]);
  const [colDefs, setColDefs] = useState([]);
  const [reportInfo, setReportInfo] = useState([]);
  const [reportInfoSub, setReportInfoSub] = useState([]);
  const [reportFilters, setReportFilters] = useState([]);
  const [staffDDL, setStaffDDL] = useState([]);
  const [storeDDL, setStoreDDL] = useState([]);
  const [productDDL, setProductDDL] = useState([]);
  const [supplierDDL, setSupplierDDL] = useState([]);
  const [customerDDL, setCustomerDDL] = useState([]);
  const [categoryDDL, setCategoryDDL] = useState([]);
  const [citiesDDL, setCitiesDDL] = useState([]);
  const [loading, setLoading] = useState(false);
  const [gridApi, setGridApi] = useState(null);
  const [taxColumnField, setTaxColumnField] = useState(null);
  // const [terminalsDDL, setTerminalsDDL] = useState([]);
  // const [cumulativeTotalTax, setCumulativeTotalTax] = useState(0);
  // const previousPageRef = useRef(null);

  const getFormattedDate = (date) => {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  };

  const [selectedFromDate, setSelectedFromDate] = useState("");
  const [selectedToDate, setSelectedToDate] = useState(
    getFormattedDate(new Date())
  );
  const [selectedStaff, setSelectedStaff] = useState(null);
  const [selectedStore, setSelectedStore] = useState(null);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [selectedSupplier, setSelectedSupplier] = useState(null);
  const [selectedCustomer, setSelectedCustomer] = useState(null);
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [selectedCity, setSelectedCity] = useState(null);
  const [selectedIndStatus, setSelectedIndStatus] = useState(null);

  useEffect(() => {
    const userDataString = sessionStorage.getItem("userData");
    const supplierData = JSON.parse(
      sessionStorage.getItem("filteredDDLData_Supplier")
    );
    const customerData = JSON.parse(
      sessionStorage.getItem("filteredDDLData_Customers")
    );
    const categoryData = JSON.parse(
      sessionStorage.getItem("filteredDDLData_CATEGORY")
    );
    const citiesData = JSON.parse(
      sessionStorage.getItem("filteredDDLData_Cities")
    );
    const staffData = JSON.parse(
      sessionStorage.getItem("filteredDDLData_Staff")
    );

    if (userDataString) {
      const userData = JSON.parse(userDataString);
      setUserDataSession(userData);
      setStaffDDL(staffData);
      setSupplierDDL(supplierData);
      setCustomerDDL(customerData);
      setCategoryDDL(categoryData);
      setCitiesDDL(citiesData);
    } else {
      console.log("User data not found in sessionStorage");
    }
  }, []);

  const indStatusOptions = [
    { value: "0", label: "All" },
    { value: "2", label: "Submitted" },
    { value: "3", label: "Approved" },
    { value: "4", label: "Reject" },
    { value: "5", label: "Completed" },
  ];

  const localIndStatusOptions = [
    { value: "12", label: "Local Purchase Submitted" },
    { value: "13", label: "Local Purchase Approved" },
    { value: "14", label: "Local Purchase Reject" },
    { value: "15", label: "Local Purchase Completed" },
  ];

  useEffect(() => {
    if (userDataSession && userDataSession.OrgId) {
      const requestData = {
        OrgId: userDataSession.OrgId,
        CategoryId: 0,
        BarCode: "0",
        IsActive: 1,
        ProductId: 0,
        StoreId: 0,
        IsForSale: 1,
        UserId: userDataSession.UserId,
        Type: 0,
      };

      Axios.post(`${API_BASE_URL}${GET_VSTORE_PROD}`, requestData)
        .then((response) => {
          if (response.data.Status) {
            setProductDDL(response.data.ResultData);
          } else {
            console.error("Error fetching data:", response.data.Message);
          }
        })
        .catch((error) => {
          console.error("Error fetching data:", error);
        });
    }
  }, [userDataSession]);

  useEffect(() => {
    if (userDataSession && userDataSession.OrgId) {
      Axios.get(
        `${API_BASE_URL}${GET_USER_STORES}?OrgId=${userDataSession.OrgId}&UserId=${userDataSession.UserId}`
      )
        .then((response) => {
          if (response.data && response.data.ResultData) {
            const stores = response.data.ResultData;
            setStoreDDL(stores);
            if (stores.length === 1) {
              console.log("true");
              const singleStore = stores[0];
              const option = {
                value: singleStore.StoreId,
                label: singleStore.Name,
              };
              setSelectedStore(option);
              console.log("Auto-selected single store:", option);
            } else {
              setSelectedStore(null);
            }
          }
        })
        .catch((error) => {
          console.error("Error fetching data:", error);
        });
    }
  }, [userDataSession]);

// useEffect(() => {
//   // Early return if we don't have required data
//   if (!userDataSession?.OrgId || !userDataSession?.UserId) {
//     return;
//   }

//   const fetchUsers = async () => {
//     try {
//       const response = await Axios.get(
//         `${API_BASE_URL}admin/getTerminalsDDL?OrgId=${userDataSession.OrgId}&UserId=${userDataSession.UserId}`
//       );

//       if (response.data?.Status) {
//         setTerminalsDDL(response.data.ResultData || []);
//       } else {
//         console.warn("API returned unsuccessful status:", response.data);
//       }
//     } catch (error) {
//       console.error("Error fetching users dropdown:", error);
 
//     }
//   };

//   fetchUsers();

// }, [userDataSession?.OrgId, userDataSession?.UserId]);

  useEffect(() => {
    const firstDateOfMonth = new Date();
    firstDateOfMonth.setDate(1);
    setSelectedFromDate(getFormattedDate(firstDateOfMonth));
    setSelectedToDate(getFormattedDate(new Date()));
  }, []);
console.log(storeDDL.length, "Storeslength")
  useEffect(() => {
    if (reportid) {
      const firstDateOfMonth = new Date();
      firstDateOfMonth.setDate(1);
      setSelectedFromDate(getFormattedDate(firstDateOfMonth));
      setSelectedToDate(getFormattedDate(new Date()));
      setSelectedCategory(null);
      setSelectedCustomer(null);
      setSelectedProduct(null);
      setSelectedStaff(null);
      // storeDDL?.length > 1 ? setSelectedStore(null) : "";
      setSelectedCity(null);
      setSelectedSupplier(null);
      setSelectedIndStatus(null);
      setReportInfoSub([]);
      setColDefs([]);
      setRowData([]);
      // setCumulativeTotalTax(0); // Reset cumulative total when reportid changes
    }
  }, [reportid]);

  useEffect(()=>{
    if(reportid && storeDDL?.length >1){
setSelectedStore(null)
    }
  },[reportid])

  useEffect(() => {
    if (userDataSession && userDataSession.OrgId && reportid) {
      Axios.get(
        `${API_BASE_URL}${GET_REPORT_FILTERS}?OrgId=${userDataSession.OrgId}UserId=${userDataSession.UserId}&ReportId=${reportid}`
      )
        .then((response) => {
          if (response.data.Status) {
            setReportFilters(response.data.ResultData[0]);
            setReportInfo(response.data.ResultData);
            console.log(response.data.ResultData[0], "filters data");
          } else {
            console.error("Error fetching data:", response.data.Message);
          }
        })
        .catch((error) => {
          console.error("Error fetching data:", error);
        });
    }
  }, [userDataSession, reportid]);

  const filtersArray = reportFilters.ReportFilter
    ? reportFilters.ReportFilter.split(",")
    : [];

  const handleFromDateChange = (event) => {
    setSelectedFromDate(event.target.value);
  };

  const handleToDateChange = (event) => {
    setSelectedToDate(event.target.value);
  };

  const handleStaffChange = (selectedOption) => {
    setSelectedStaff(selectedOption);
  };

  const handleStoreChange = (selectedOption) => {
    setSelectedStore(selectedOption);
  };

  const handleSupplierChange = (selectedOption) => {
    setSelectedSupplier(selectedOption);
  };

  const handleCustomerChange = (selectedOption) => {
    setSelectedCustomer(selectedOption);
  };

  const handleProductChange = (selectedOption) => {
    setSelectedProduct(selectedOption);
  };

  const handleCategoryChange = (selectedOption) => {
    setSelectedCategory(selectedOption);
  };

  const handleCityChange = (selectedOption) => {
    setSelectedCity(selectedOption);
  };

  const handleIndStatusChange = (selectedOption) => {
    setSelectedIndStatus(selectedOption);
  };

  const handleSearch = () => {
    if (userDataSession && userDataSession.OrgId) {
      setLoading(true);

      const requestData = {
        OrgId: userDataSession.OrgId,
        UserId: userDataSession.UserId,
        ReportId: reportid,
        ReportCriteria: {
          FromDate: selectedFromDate,
          ToDate: selectedToDate,
          ProductId: selectedProduct ? selectedProduct.value : "0",
          SupplierId: selectedSupplier ? selectedSupplier.value : "0",
          UserId: selectedStaff ? selectedStaff.value : "0",
          LoginUserId: userDataSession ? userDataSession.UserId : "0",
          StoreId: selectedStore ? selectedStore.value : "0",
          CustomerId: selectedCustomer ? selectedCustomer.value : "0",
          CategoryId: selectedCategory ? selectedCategory.value : "0",
          City: selectedCity ? selectedCity.value : "0",
          Status: selectedIndStatus ? selectedIndStatus.value : "0",
        },
      };
      console.log(requestData, "data sending to api");

      Axios.post(`${API_BASE_URL}${GET_REPORT_DATA}`, requestData)
        .then((response) => {
          console.log(response.data, "response from service");
          if (response.data) {
            const { data, headers, reportinfo } = response.data;
            console.log(response.data, "data getting from api");
            const colDefs = headers.map((header, index) => ({
              headerName: header,
              field: `col${index}`,
              sortable: true,
              filter: true,
            }));

            const rowData = data.map((row) => {
              const rowDataObj = {};
              headers.forEach((header, index) => {
                rowDataObj[`col${index}`] = row[Object.keys(row)[index]];
              });
              return rowDataObj;
            });

            // Identify the TotalTaxes column
            const taxCol = colDefs.find(
              (col) => col.headerName === "TotalTaxes"
            );
            if (taxCol) {
              setTaxColumnField(taxCol.field);
              console.log("TotalTaxes column found:", taxCol.field);
            } else {
              console.warn("TotalTaxes column not found in headers:", headers);
            }

            setRowData(rowData);
            setColDefs(colDefs);
            setReportInfoSub(reportinfo);
            setLoading(false);
            // setCumulativeTotalTax(0); // Reset cumulative total on new search
          } else {
            console.error("Error fetching data:", response.data);
            setLoading(false);
          }
        })
        .catch((error) => {
          console.error("Error fetching data:", error);
          setLoading(false);
        });
    }
  };

const isNumericValue = (value) => {
  if (value == null || value === "") return false;
  const str = String(value).trim();
  

  if (/[-/:]/.test(str) || /[a-zA-Z]/.test(str)) return false;
  
  const num = parseFloat(str);
  return !isNaN(num) && isFinite(num);
};

const calculateTotalTax = useCallback(() => {
  if (!gridApi || rowData.length === 0) {
    gridApi?.setPinnedBottomRowData([]);
    return;
  }

  
  const renderedNodes = gridApi.getRenderedNodes() || [];

  
  const numericCols = colDefs
    .map((c) => c.field)
    .filter((field) =>
      renderedNodes.some((node) => node.data && isNumericValue(node.data[field]))
    );

  const pageTotals = {};
  numericCols.forEach((col) => (pageTotals[col] = 0));


  renderedNodes.forEach((node) => {
    if (!node || !node.data) return;

    numericCols.forEach((col) => {
      const raw = node.data[col];
      const v = parseFloat(raw);
      if (!isNaN(v)) pageTotals[col] += v;
    });
  });


  const pinnedRow = {};
  colDefs.forEach((col, index) => {
    if (index === 0) {
      pinnedRow[col.field] = "Total";
    } else if (numericCols.includes(col.field)) {
      pinnedRow[col.field] = Number(pageTotals[col.field]).toFixed(2);
    } else {
      pinnedRow[col.field] = "";
    }
  });

  gridApi.setPinnedBottomRowData([pinnedRow]);
}, [gridApi, colDefs, rowData]);

  useEffect(() => {
    calculateTotalTax();
  }, [rowData, gridApi, colDefs, calculateTotalTax]);

  const handleDownloadExcel = () => {
    if (rowData.length === 0) {
      console.warn("No data to export to Excel");
      return;
    }

    const headers = colDefs.map((col) => col.headerName);
    const wsData = rowData.map((item) => {
      const row = {};
      colDefs.forEach((col) => {
        row[col.headerName] = item[col.field];
      });
      return row;
    });

    let totalTax = 0;
    rowData.forEach((item) => {
      const taxValue = parseFloat(item[taxColumnField]) || 0;
      totalTax += taxValue;
    });

    if (taxColumnField) {
      const taxHeader = colDefs.find(
        (col) => col.field === taxColumnField
      ).headerName;
      wsData.push({
        [taxHeader]: `Total: ${totalTax.toFixed(2)}`,
      });
    }

    const wb = XLSX.utils.book_new();
    const ws = XLSX.utils.json_to_sheet(wsData, { header: headers });
    XLSX.utils.book_append_sheet(wb, ws, "ReportsData");
    XLSX.writeFile(wb, "ReportsData.xlsx");
  };

  const generatePDF = () => {
    if (rowData.length === 0) {
      console.warn("No data to export to PDF");
      return;
    }

    const doc = new jsPDF({
      orientation: "landscape",
    });

    doc.setProperties({
      title: "Reports Data",
      author: "Ibiz",
      creator: "Ibiz Application",
    });

    const logoUrl = PDFLOGO;
    const logoX = 10;
    const logoY = 10;
    const logoWidth = 65;
    const logoHeight = 20;

    doc.addImage(logoUrl, "PNG", logoX, logoY, logoWidth, logoHeight);

    const headers = colDefs.map((col) => col.headerName);
    const tableData = rowData.map((item) =>
      headers.map((header) => {
        const field = colDefs.find((col) => col.headerName === header).field;
        return item[field] || "";
      })
    );

    // Calculate total tax for all data in export
    let totalTax = 0;
    rowData.forEach((item) => {
      const taxValue = parseFloat(item[taxColumnField]) || 0;
      totalTax += taxValue;
    });

    if (taxColumnField) {
      const taxHeader = colDefs.find(
        (col) => col.field === taxColumnField
      ).headerName;
      const emptyRow = headers.map(() => "");
      emptyRow[headers.indexOf(taxHeader)] = `Total: ${totalTax.toFixed(2)}`;
      tableData.push(emptyRow);
    }

    doc.autoTable({
      head: [headers],
      body: tableData,
      startY: logoY + logoHeight + 10,
      margin: { horizontal: 10 },
      styles: {
        overflow: "linebreak",
        cellPadding: 3,
        fontSize: 10,
        valign: "middle",
        cellWidth: "wrap",
      },
      headStyles: {
        fillColor: [22, 160, 133],
        textColor: [255, 255, 255],
        fontStyle: "bold",
      },
      bodyStyles: {
        fillColor: [255, 255, 255],
        textColor: [0, 0, 0],
      },
      columnStyles: {
        0: { cellWidth: 30 },
        1: { cellWidth: 30 },
        2: { cellWidth: 40 },
      },
      didDrawPage: function (data) {
        doc.setFontSize(12);
        doc.text(" Report", 10, 10);
        doc.text(
          `Page ${data.pageCount}`,
          doc.internal.pageSize.width - 20,
          10
        );
      },
      pageBreak: "auto",
    });

    doc.save("ReportsData.pdf");
  };

  const handleReload = () => {
    window.location.reload();
  };

  const onGridReady = useCallback((params) => {
    setGridApi(params.api);
    params.api.sizeColumnsToFit();
  }, []);

  const onPaginationChanged = useCallback(() => {
    console.log("Pagination changed, recalculating totals");
    calculateTotalTax();
  }, [calculateTotalTax]);

  return (
    <div className="page-wrapper">
      <div className="content">
        <div className="page-header transfer">
          <div className="add-item d-flex">
            <div className="page-title">
              <h4>{reportInfo[0] && reportInfo[0].ReportTitle}</h4>
              <h6>{reportInfoSub[0] && reportInfoSub[0]["Report Tit"]}</h6>
            </div>
          </div>
          <ul className="table-top-head">
            <li>
              <button className="btn border">
                <img
                  src={EXCELIMG}
                  alt="ExcelImg"
                  onClick={handleDownloadExcel}
                />
              </button>
            </li>
            <li>
              <button className="btn border">
                <img src={PDFIMG} alt="PDFIMG" onClick={generatePDF} />
              </button>
            </li>
            <li onClick={handleReload}>
              <button className="btn border">
                <i className="fa-solid fa-rotate-right fs-5"></i>
              </button>
            </li>
          </ul>
        </div>
        <div className="card table-list-card">
          <div className="row my-2 ms-2">
            {filtersArray.includes("FromDate") && (
              <div className="col-lg-2 col-sm-6 col-12">
                <label className="form-label">From Date</label>
                <div className="input-bloks">
                  <input
                    className="form-control"
                    type="date"
                    value={selectedFromDate}
                    onChange={handleFromDateChange}
                  />
                </div>
              </div>
            )}
            {filtersArray.includes("ToDate") && (
              <div className="col-lg-2 col-sm-6 col-12">
                <label className="form-label">To Date</label>
                <div className="input-bloks">
                  <input
                    className="form-control"
                    type="date"
                    value={selectedToDate}
                    onChange={handleToDateChange}
                  />
                </div>
              </div>
            )}
            {filtersArray.includes("StoreId") && (
              <div className="col-lg-2 col-sm-6 col-12">
                <label className="form-label">Store</label>
                <div className="input-bloks">
                  <Select
                    className="select"
                    id="storeSelect"
                    value={selectedStore}
                    onChange={handleStoreChange}
                    options={
                      storeDDL?.map((store) => ({
                        value: store.StoreId,
                        label: store.Name,
                      })) || []
                    }
                    placeholder="Choose store"
                    isSearchable={storeDDL && storeDDL.length > 1}
                    styles={{
                      placeholder: (base) => ({
                        ...base,
                        display: selectedStore ? "none" : "block",
                      }),
                    }}
                  />
                </div>
              </div>
            )}
            {filtersArray.includes("CategoryId") && (
              <div className="col-lg-2 col-sm-6 col-12">
                <label className="form-label">Category</label>
                <div className="input-bloks">
                  <Select
                    className="select"
                    id="productSelect"
                    value={selectedCategory || null}
                    onChange={handleCategoryChange}
                    options={
                      categoryDDL
                        ? [
                            { value: 0, label: "All" },
                            ...categoryDDL.map((prod) => ({
                              value: prod.ItemId,
                              label: prod.ItemValue,
                            })),
                          ]
                        : [{ value: 0, label: "All" }]
                    }
                    placeholder="Choose category"
                  />
                </div>
              </div>
            )}
            {filtersArray.includes("City") && (
              <div className="col-lg-2 col-sm-6 col-12">
                <label className="form-label">City</label>
                <div className="input-bloks">
                  <Select
                    className="select"
                    id="citySelect"
                    value={selectedCity || null}
                    onChange={handleCityChange}
                    options={
                      citiesDDL
                        ? [
                            { value: 0, label: "All" },
                            ...citiesDDL.map((prod) => ({
                              value: prod.ItemValue,
                              label: prod.ItemValue,
                            })),
                          ]
                        : [{ value: 0, label: "All" }]
                    }
                    placeholder="Choose city"
                  />
                </div>
              </div>
            )}
            {filtersArray.includes("Status") && (
              <div className="col-lg-2 col-sm-6 col-12">
                <label className="form-label">Status</label>
                <div className="input-bloks">
                  <Select
                    className="select"
                    id="statusSelect"
                    value={selectedIndStatus || null}
                    onChange={handleIndStatusChange}
                    options={indStatusOptions}
                    placeholder="Choose status"
                  />
                </div>
              </div>
            )}
            {filtersArray.includes("LocalStatus") && (
              <div className="col-lg-2 col-sm-6 col-12">
                <label className="form-label">Status</label>
                <div className="input-bloks">
                  <Select
                    className="select"
                    id="statusSelect"
                    value={selectedIndStatus || null}
                    onChange={handleIndStatusChange}
                    options={localIndStatusOptions}
                    placeholder="Choose status"
                  />
                </div>
              </div>
            )}
            {filtersArray.includes("SupplierId") && (
              <div className="col-lg-2 col-sm-6 col-12">
                <label className="form-label">Supplier</label>
                <div className="input-bloks">
                  <Select
                    className="select"
                    id="productSelect"
                    value={selectedSupplier || null}
                    onChange={handleSupplierChange}
                    options={
                      supplierDDL
                        ? [
                            { value: 0, label: "All" },
                            ...supplierDDL.map((prod) => ({
                              value: prod.ItemId,
                              label: prod.ItemValue,
                            })),
                          ]
                        : [{ value: 0, label: "All" }]
                    }
                    placeholder="Choose supplier"
                  />
                </div>
              </div>
            )}
            {filtersArray.includes("CustomerId") && (
              <div className="col-lg-2 col-sm-6 col-12">
                <label className="form-label">Customer</label>
                <div className="input-bloks">
                  <Select
                    className="select"
                    value={selectedCustomer || null}
                    onChange={handleCustomerChange}
                    options={
                      customerDDL
                        ? [
                            { value: 0, label: "All" },
                            ...customerDDL.map((prod) => ({
                              value: prod.ItemId,
                              label: prod.ItemValue,
                            })),
                          ]
                        : [{ value: 0, label: "All" }]
                    }
                    placeholder="Choose customer"
                  />
                </div>
              </div>
            )}
            {filtersArray.includes("ProductId") && (
              <div className="col-lg-2 col-sm-6 col-12">
                <label className="form-label">Product</label>
                <div className="input-bloks">
                  <Select
                    className="select"
                    value={selectedProduct || null}
                    onChange={handleProductChange}
                    options={productDDL.map((prod) => ({
                      value: prod.Id,
                      label: prod.ProductName,
                    }))}
                    placeholder="Choose product"
                  />
                </div>
              </div>
            )}
            {filtersArray.includes("UserId") && (
              <div className="col-lg-2 col-sm-6 col-12">
                <label className="form-label">Employee</label>
                <div className="input-bloks">
                  <Select
                    className="select"
                    id="employeeSelect"
                    value={selectedStaff || null}
                    onChange={handleStaffChange}
                    options={
                      staffDDL
                        ? [
                            { value: 0, label: "All" },
                            ...staffDDL.map((prod) => ({
                              value: prod.ItemId,
                              label: prod.ItemValue,
                            })),
                          ]
                        : [{ value: 0, label: "All" }]
                    }
                    placeholder="Choose employee"
                  />
                </div>
              </div>
            )}

            {/* {
            filtersArray.includes("TerminalId") && (
              <div className="col-lg-2 col-sm-6 col-12">
                <label className="form-label">Terminal</label>
                <div className="input-bloks">
                  <Select
                    className="select"
                    id="terminalSelect"
                    value={selectedStore}
                    onChange={handleStoreChange}
                    options={
                      terminalsDDL?.map((terminal) => ({
                        value: terminal.TerminalId,
                        label: terminal.Name,
                      })) || []
                    }
                    placeholder="Choose terminal"
                    isSearchable={terminalsDDL && terminalsDDL.length > 1}
                    styles={{
                      placeholder: (base) => ({
                        ...base,
                        display: selectedStore ? "none" : "block",
                      }),
                    }}
                  />
                </div>
              </div>
            )   
            } */}
            <div className="col-md-1 col-sm-1 col-lg-1 mt-4">
              <button className="btn btn-primary" onClick={handleSearch}>
                <i className="fa-solid fa-magnifying-glass"></i>
              </button>
            </div>
          </div>
          <div
            className="ag-theme-alpine"
            style={{ height: 380, width: "100%" }}
          >
            {loading ? (
              <SpinLoader />
            ) : (
              // <div className="loader m-auto mt-5"></div>
              <AgGridReact
                defaultColDef={{ sortable: true, filter: true, flex: 1 }}
                pagination={true}
                paginationPageSize={10}
                rowData={rowData}
                columnDefs={colDefs}
                onGridReady={onGridReady}
                onPaginationChanged={onPaginationChanged}
                pinnedBottomRowData={[
                  { col0: "Total", col1: "", col2: "", col3: "", col4: "0.00" },
                ]} // Initial pinned row 
                domLayout="autoHeight"
              />
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

